import {Component, HostListener, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import {UserReadableDto, UsersService} from '../../services/users.service';
import {AuthService} from '../../services/auth.service';
import {AuthenticatedStatus} from '../../services/auth-token.service';
import {MatDrawer, MatDrawerContent} from '@angular/material/sidenav';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';

@Component({
  selector: 's-ori-page-template',
  templateUrl: './ori-page-template.component.html',
  styleUrls: ['./ori-page-template.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ORIPageTemplateComponent implements OnInit {
  public isAuthorized: boolean;
  public userName: string;
  public user: UserReadableDto;
  public sidebarClosingMode = true;

  @ViewChild('navigationMenu', {static: true})
  private navigationMenu: MatDrawer;

  @ViewChild('drawerContent', {static: true})
  private drawerContent: MatDrawerContent;

  public constructor(
    private authService: AuthService,
    private userService: UsersService,
    private router: Router,
  ) {
  }

  public ngOnInit() {
    this.loadAuthorizeInfo();
    this.router.events.pipe(
      filter((a,b) => b && a instanceof NavigationEnd)
    ).subscribe(_ => {
      if (this.sidebarClosingMode) {
        this.navigationMenu.close();
      }
    });
  }

  private loadAuthorizeInfo(): void {
    this.authService.getStatus().subscribe(status => {
      this.isAuthorized = status === AuthenticatedStatus.authenticated;
    });

    this.userService.getCurrentUser()
      .subscribe(value => {
        this.user = value;
        this.userName = `${value.firstName} ${value.lastName}`;
      });
  }

  @HostListener('document:click', ['$event.target'])
  public handleSidebarOuterClick(target) {
    if (this.sidebarClosingMode) {
      const clickedInside = this.drawerContent.getElementRef().nativeElement.contains(target);
      if (clickedInside && this.navigationMenu.opened) {
        this.navigationMenu.close();
      }
    }
  }

}
